import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Image, Scissors } from 'lucide-react';

const MobileNav: React.FC = () => {
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav className="mobile-nav md:hidden fixed bottom-0 left-0 right-0 bg-white/95 dark:bg-gray-900/95 backdrop-blur-sm border-t border-gray-200 dark:border-gray-800 z-40">
      <div className="flex justify-around items-center h-16">
        <Link to="/" className={`nav-item ${isActive('/') ? 'active' : ''}`}>
          <Home className="w-6 h-6 mb-1" />
          <span>Home</span>
        </Link>
        <Link to="/gallery" className={`nav-item ${isActive('/gallery') ? 'active' : ''}`}>
          <Image className="w-6 h-6 mb-1" />
          <span>Styles</span>
        </Link>
        <Link to="/booking" className={`nav-item ${isActive('/booking') ? 'active' : ''}`}>
          <Scissors className="w-6 h-6 mb-1" />
          <span>Book</span>
        </Link>
      </div>
    </nav>
  );
}

export default MobileNav;